import { Box, Skeleton, Tooltip } from "@mui/material";
import { AvaibilityType } from "../../../../../explorer/types/Basket/BasketItems";
import { useTranslation } from "../../../../../explorer/hooks/useTranslation";
import { useTableLayoutClasses } from "../TableLayout.style";
import CircleIcon from "@mui/icons-material/Circle";
import { green, orange, red, yellow, grey } from "@mui/material/colors";

type TAvaibilityComponent = {
    item: any;
    additionalProps: any;
};

const AvaibilityIcon = (avaibility: AvaibilityType) => {
    if (!avaibility) return <></>;
    switch (avaibility) {
        case AvaibilityType.Green:
            return <CircleIcon sx={{ color: green[500] }} />;
        case AvaibilityType.Yellow:
            return <CircleIcon sx={{ color: yellow[500] }} />;
        case AvaibilityType.Orange:
            return <CircleIcon sx={{ color: yellow[500] }} />; // usiamo il giallo per due stati
        case AvaibilityType.Red:
            return <CircleIcon sx={{ color: red[500] }} />;
        case AvaibilityType.Grey:
                return <CircleIcon sx={{ color: "transparent" }} />;
        default:
            return <></>;
    }
};

const AvaibilityIconComponent = (props: TAvaibilityComponent) => {
    const classes = useTableLayoutClasses();
    const { t } = useTranslation();
    return (
        <Box key={props.item.code} sx={[classes.iconCell]}>
            {!props.additionalProps.loadingPrices && !props.additionalProps?.listDisabledRow?.current?.includes(props.item.rowId) ? (
                <Tooltip
                    children={AvaibilityIcon(props.item.availabilityStatus)}
                    title={t(`common.basket.${props.item.availabilityStatus}`)}
                    placement="top"
                    disableInteractive
                />
            ) : (
                <Skeleton variant="circular" width={20} height={20} />
            )}
        </Box>
    );
};

export default AvaibilityIconComponent;
